import { COLUMN_ACCESS, COLUMN_CATEGORY, COLUMN_COMPANY, COLUMN_DEPARTMENT, COLUMN_EXPIRED, COLUMN_EXPIRY_DATE, COLUMN_FIRST_NAME, COLUMN_LAST_NAME, COLUMN_NAME, COLUMN_SECOND_NAME, COLUMN_SUFFIX, COLUMN_TAG_CODE, COLUMN_TIME, COLUMN_TITLE, COLUMN_TYPE, COLUMN_UNIQUE_IDENTIFIER } from '../../constants/column-types';
import { FILTER_COMPANIES, FILTER_DEPARTMENTS, FILTER_PROFILE, FILTER_TAGHOLDERS } from '../../constants/filter-types';
import { TableColumn } from '../table/TableColumn';
import { ColumnFormattingClasses } from './constants/ColumnFormattingClasses';

const ExpiredCredentialReportColumn: TableColumn[] = [
    {
        heading: "Display Name",
        accessor: "displayName",
        isNumeric: false,
        id: 1,
        sortByName: "mstDisplayname",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
        lookupName: "master.mstDisplayname",
        searchOnName: "masterId",
        filterId: FILTER_TAGHOLDERS,
        settingDataName: 'master'
    },
    {
        heading: "Unique Identifier",
        accessor: "idNumber",
        isNumeric: false,
        id: 2,
        sortByName: "mstIdnumber",
        sortDirection: "asc",
        active: true,
        translationKey: "uniqueIdentifier",
        columnId: COLUMN_UNIQUE_IDENTIFIER,
    },
    {
        heading: "Suffix",
        accessor: "suffix",
        isNumeric: false,
        id: 3,
        sortByName: "mstSuffix",
        active: false,
        translationKey: "suffix",
        columnId: COLUMN_SUFFIX,
    },
    {
        heading: "Access Type",
        accessor: "type",
        isNumeric: false,
        id: 4,
        sortByName: "mtName",
        sortDirection: "asc",
        active: true,
        translationKey: "accessType",
        columnId: COLUMN_ACCESS,
    },
    {
        heading: "Company",
        accessor: "companyName",
        isNumeric: false,
        id: 5,
        sortByName: "compName",
        sortDirection: "asc",
        searchOnName: "companyId",
        lookupName: "compName",
        active: true,
        translationKey: "company",
        columnId: COLUMN_COMPANY,
        filterId: FILTER_COMPANIES,
        settingDataName: "company",
    },
    {
        heading: "Department",
        accessor: "departmentName",
        isNumeric: false,
        id: 6,
        sortByName: "deptName",
        active: true,
        searchOnName: "departmentId",
        sortDirection: "asc",
        lookupName: "deptName",
        translationKey: "department",
        columnId: COLUMN_DEPARTMENT,
        filterId: FILTER_DEPARTMENTS,
        settingDataName: "department",
    },
    {
        heading: "Expiry Date",
        accessor: "expiryDate",
        isNumeric: false,
        id: 7,
        sortByName: "expDateDisplay",
        sortDirection: "asc",
        active: true,
        translationKey: "expiryDate",
        columnId: COLUMN_EXPIRY_DATE,
    },
    {
        heading: "Expiry Time",
        accessor: "expiryTime",
        isNumeric: false,
        id: 15,
        sortByName: "expTime",
        sortDirection: "asc",
        active: true,
        translationKey: "expiryTime",
        columnId: COLUMN_TIME,
    },
    {
        heading: "Card Number",
        accessor: "tagCode",
        isNumeric: true,
        id: 8,
        sortByName: "tagCode",
        active: true,
        sortDirection: "asc",
        translationKey: "cardNumber",
        columnId: COLUMN_TAG_CODE,
    },
    {
        heading: "Expired",
        accessor: "expired",
        isNumeric: false,
        id: 9,
        sortByName: "expired",
        sortDirection: "asc",
        active: true,
        translationKey: "expired",
        valueFormatting: (value) => {
            const valueFormats = {
                No: ColumnFormattingClasses.categoryGreen,
                Yes: ColumnFormattingClasses.categoryRed,
            };
            return valueFormats[value];
        },
        columnId: COLUMN_EXPIRED,
    },
    {
        heading: "First Name",
        accessor: "firstName",
        isNumeric: false,
        id: 10,
        sortByName: "mstFirstname",
        sortDirection: "asc",
        active: false,
        translationKey: "firstName",
        columnId: COLUMN_FIRST_NAME,
    },
    {
        heading: "Second Name",
        accessor: "middleName",
        isNumeric: false,
        id: 11,
        sortByName: "mstMiddlename",
        sortDirection: "asc",
        active: false,
        translationKey: "secondName",
        columnId: COLUMN_SECOND_NAME,
    },
    {
        heading: "Last Name",
        accessor: "lastName",
        isNumeric: false,
        id: 12,
        sortByName: "mstLastname",
        sortDirection: "asc",
        active: false,
        translationKey: "lastName",
        columnId: COLUMN_LAST_NAME,
    },
    {
        heading: "Title",
        accessor: "title",
        isNumeric: false,
        id: 13,
        sortByName: "mstTitle",
        sortDirection: "asc",
        active: false,
        translationKey: "title",
        columnId: COLUMN_TITLE,
    },
    {
        heading: "Category",
        accessor: "category",
        isNumeric: false,
        id: 14,
        sortByName: "profileName",
        sortDirection: "asc",
        active: false,
        translationKey: "category",
        searchOnName: "profileId",
        lookupName: "profileId",
        columnId: COLUMN_CATEGORY,
        filterId: FILTER_PROFILE,
        settingDataName: "profile",
    },
];
export default ExpiredCredentialReportColumn;
